/**
 * Hardcoded allowlist of admin email addresses.
 * Comparisons must be case-insensitive; normalization happens in auth.js.
 */
export const ADMIN_EMAILS = [
  "devon@neutrinodesign.com",
  "jessica@qentoros.com",
];
